import React from 'react';
import Tiles from '../Tiles';

const Menu = props => {
  return <Tiles {...props} />;
};

export default Menu;
